module.exports = "/images/sophia.jpg?a0f4593b9a27a1c9ffd3eb7e0a43b68c";